import { withOverrideLegacy } from '~/App/hocs/with-override-legacy';

import { Vacancy } from './Vacancy';
import { loadData } from './Vacancy.LoadData';

export default withOverrideLegacy(Vacancy, loadData);
